<template>
    <div class="memberList">
        <v-card class="cardWrap">
            <CardTitle title="リクエスト予約状況照会" />
            <template>
                <v-form
                    ref="form"
                    lazy-validation
                    >
                    <v-row no-gutters class="mx-3">
                        <div class="column-width"><v-text-field
                            class="mr-3 pt-4"
                            label="予約番号"
                            maxlength="12"
                            v-model="search.reserveNo"
                        /></div>
                        <!--
                        # 注意事項

                        以下の年月日の入力項目では、入力形式を YYYY-MM-DD としており、数字入力時にハイフンが自動で補完されるようになっている。
                        （keyup イベント時に formatDate 関数を呼び出しそれを行っている）

                        しかし、IMEが全角モードで数字を入力すると、上記の補完がうまく動作せず、入力した数字が二重で入ってしまう。
                        例）2021と入力すると、2021-20-21と入ってしまう。

                        この現象の回避策として、type に tel を指定することで、IMEモードがOFFになり、半角でのみ入力できるようにする。

                        なお、この年月日は手入力のみ許可するため、type に date は指定していない。
                        （date を指定するとカレンダーが表示されてしまう）
                        -->
                        <div class="date-width"><v-menu
                            ref="menu"
                            v-model="reserveMenu"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y min-width="290px"
                        >
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                    class="mr-3 pt-4"
                                    label="申込日"
                                    inputmode="tel"
                                    type="tel"
                                    placeholder="0000-00-00"
                                    maxlength="10"
                                    v-on="on"
                                    v-model="formatedReserveDate"
                                    @focus="focusDate(search.applicationDate)"
                                    @keyup.delete="deleteKeyUpApplicationDate($event)"
                                    @keyup="search.applicationDate = formatDate(search.applicationDate)"
                                    @keydown.tab.exact="reserveMenu = false"
                                    :rules="[rules.string_type,
                                            rules.format_date,
                                            rules.correct_date]"
                                />
                            </template>
                            <v-date-picker
                                ref="picker"
                                v-model="search.applicationDate"
                                locale="jp-ja"
                                :day-format="date => new Date(date).getDate()"
                                min="1900-01-01"
                                @input="reserveMenu = false"
                            />
                        </v-menu></div>
                        <!-- <div><v-select
                            class="mr-3 pt-4"
                            label="予約状況"
                            :items="reserveSituationData"
                            item-value="code"
                            item-text="code_name"
                            v-model="search.reserveSituation"
                        /></div> -->
                        <div class="golf-width"><v-select
                            class="mr-3 pt-4"
                            :items="golfSelect"
                            item-value="golf_code"
                            item-text="golf_name"
                            v-model="search.golfCode"
                            label="ゴルフ場名"
                        ></v-select></div>
                        <div class="column-width"><v-text-field
                            class="mr-3"
                            label="会員No"
                            v-model="search.memberNo"
                        /></div>
                        <div class="column-width"><v-text-field
                            class="mr-3"
                            label="代表者（姓）"
                            v-model="search.familyName"
                        /></div>
                        <div class="column-width"><v-text-field
                            class="mr-3"
                            label="代表者（名）"
                            v-model="search.givenName"
                        /></div>
                        <!--
                        # 注意事項

                        以下の年月日の入力項目では、入力形式を YYYY-MM-DD としており、数字入力時にハイフンが自動で補完されるようになっている。
                        （keyup イベント時に formatDate 関数を呼び出しそれを行っている）

                        しかし、IMEが全角モードで数字を入力すると、上記の補完がうまく動作せず、入力した数字が二重で入ってしまう。
                        例）2021と入力すると、2021-20-21と入ってしまう。

                        この現象の回避策として、type に tel を指定することで、IMEモードがOFFになり、半角でのみ入力できるようにする。

                        なお、この年月日は手入力のみ許可するため、type に date は指定していない。
                        （date を指定するとカレンダーが表示されてしまう）
                        -->
                        <div class="date-width"><v-menu
                            ref="menu"
                            v-model="playMenu"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y min-width="290px"
                        >
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                    class="mr-3"
                                    label="プレー日"
                                    inputmode="tel"
                                    type="tel"
                                    placeholder="0000-00-00"
                                    maxlength="10"
                                    v-on="on"
                                    v-model="formatedPlayDate"
                                    @focus="focusDate(search.requestDate)"
                                    @keyup.delete="deleteKeyUpPlayDate($event)"
                                    @keyup="search.requestDate = formatDate(search.requestDate)"
                                    @keydown.tab.exact="playMenu = false"
                                    :rules="[rules.string_type,
                                            rules.format_date,
                                            rules.correct_date]"
                                />
                            </template>
                            <v-date-picker
                                ref="picker"
                                v-model="search.requestDate"
                                locale="jp-ja"
                                :day-format="date => new Date(date).getDate()"
                                min="1900-01-01"
                                @input="playMenu = false"
                            />
                        </v-menu></div>
                        <v-checkbox
                            class="mr-3 selectWidth"
                            v-model="search.completed"
                            label="未返信メッセージあり"
                        />
                        <v-btn
                            color="primary"
                            class="ml-5 mt-3"
                            v-on:click="checkValidateSearch"
                            :disabled="btn[1].isActive"
                        >検索</v-btn>
                        <v-spacer></v-spacer>
                    </v-row>
                </v-form>
            </template>
            <v-divider></v-divider>
            <v-row class="mt-2">
                <div class="ml-6 reserve-title">受付一覧</div>
                <v-spacer></v-spacer>
            </v-row>
            <v-data-table
                :headers="headers"
                :items="desserts"
                class="elevation-1"
                fixed-header
                hide-default-footer
            >
                <template v-slot:[`item.detail`]="{ item }">
                    <v-btn
                        text
                        color="primary"
                        :disabled="btn[2].isActive"
                        v-if="item.reserve_no"
                    @click="openModal(item)">
                    詳細
                    </v-btn>
                </template>
            </v-data-table>
            <v-pagination
                class="my-2"
                v-model="page"
                :length="pageCount"
                :total-visible="7"
                @input="clickPagination"
            ></v-pagination>
            <v-divider></v-divider>
            <v-row class="mt-2">
                <div class="ml-6 reserve-title">キャンセル一覧</div>
                <v-spacer></v-spacer>
            </v-row>
            <v-data-table
                :headers="headers"
                :items="cancelList"
                hide-default-footer
                class="elevation-1"
                fixed-header
            >
                <template v-slot:[`item.detail`]="{ item }">
                    <v-btn
                        text
                        color="primary"
                        :disabled="btn[2].isActive"
                        v-if="item.reserve_no"
                    @click="openModal(item)">
                    詳細
                    </v-btn>
                </template>
            </v-data-table>
            <v-pagination
                class="my-2"
                v-model="cancelPage"
                :length="cancelPageCount"
                :total-visible="7"
                @input="clickPagination"
            ></v-pagination>

            <ReserveRequestDetail
                ref="Modal"
                :detailInfo="detailInfo"
                :adminInfo="admin"
                :golfCourseSelection="golfSelect"
                :chatboxSetting="chatboxSetting"
                @refresh-event="getReserveRequestList">
            </ReserveRequestDetail>

        </v-card>
    </div>
</template>

<script>
import CardTitle from '../../components/module/CardTitle';
import validater from '../../lib/validater';
// モーダル
import ReserveRequestDetail from './modal/ReserveRequestDetail';

// mixin
import { authorityMixin } from '@/views/authorityMixin';
import { utilityMixin } from '../../mixins/utility';
import { codeListMixin } from '@/mixins/codeList';
import { golfCourseMixin } from '@/mixins/golfCourse';

// graphql
import { GET_RESERVE_REQUEST_LIST } from '@/constants/reserve';

export default {
    components: {
        CardTitle,
        ReserveRequestDetail
    },
    mixins: [
        authorityMixin,
        utilityMixin,
        codeListMixin,
        golfCourseMixin
    ],
    data () {
        return {
            page: 1,
            pageCount: 0,
            cancelPage: 1,
            cancelPageCount: 0,
            begin_row: 0,
            cancel_begin_row: 0,
            limit_rows: 10,
            // 検索キーワード
            search: {
                memberNo: '',
                familyName: '',
                givenName: '',
                requestDate: '',
                reserveType: 3,
                reserveSituation: '',
                reserveNo: '',
                applicationDate: '',
                play_date: '',
                golfCode: '',
                completed: false
            },
            // データテーブルに渡す値
            desserts: [],
            cancelList: [],
            // データテーブルの見出し要素
            headers: [
                { text: '申込日', sortable: false, value: 'reserve_datetime' },
                { text: 'プラン名', value: 'plan_name', sortable: false },
                { text: '予約種別', value: 'reserve_type_name', sortable: false },
                { text: '枠数', align: 'center', value: 'cell_number', sortable: false },
                { text: '人数', align: 'center', value: 'play_number', sortable: false },
                { text: '代表者', align: 'center', value: 'full_name', sortable: false },
                // { text: '予約状況', align: 'center', value: 'reserve_situation_name', sortable: false },
                { text: '詳細', align: 'center', value: 'detail', sortable: false }
            ],
            // 区分選択のセレクトエリアの表示値
            reserveSituationData: [],
            // 区分選択のセレクトエリアの表示値
            golfSelect: [],
            // モーダルウィンドウの状態
            dialog: false,
            // ボタンの活性・非活性
            btn: [
                { element_id: '000', element_name: '画面', isActive: true },
                { element_id: '001', element_name: '検索', isActive: true },
                { element_id: '002', element_name: '詳細', isActive: true }
            ],
            vue_id: 'SCR0022',
            detailInfo: {
                reserve_no: '',
                dialog: true
            },
            admin: {
                user_id: '',
                user_div: '',
                golf_code: ''
            },
            rules: {
                string_type: value => validater.checkDateStringType(value) || this.$t('error.validation.num'),
                format_date: value => validater.checkDateFormat(value) || this.$t('error.validation.date.Correct'),
                correct_date: value => validater.checkCorrectDate(value) || this.$t('error.validation.date.Correct')
            },
            reserveMenu: false,
            playMenu: false,
            chatboxSetting: false
        };
    },
    async created () {
        this.$store.commit('loading/setIsLoading', true);
        this.admin = await this.getLoginAdmin();
        this.reserveSituationData = await this.getCodeList('reserve_situation');
        this.reserveSituationData.unshift({ code: '', code_name: '' });
        // ステータスが予約済みのものは削除
        this.reserveSituationData = this.reserveSituationData.filter(el => el.code !== '2');
        // ステータスが来場済みのものは削除
        this.reserveSituationData = this.reserveSituationData.filter(el => el.code !== '3');
        this.golfSelect = await this.getGolfCourseList();
        this.search.golfCode = this.golfSelect[0].golf_code;
        await this.getAuthorityList();
        this.getReserveRequestList();
        this.$store.commit('loading/setIsLoading', false);
    },
    computed: {
        formatedReserveDate: {
            get () {
                return this.search.applicationDate;
            },
            set (value) {
                value = this.addHyphen(value);
                this.search.applicationDate = value;
            }
        },
        formatedPlayDate: {
            get () {
                return this.search.requestDate;
            },
            set (value) {
                value = this.addHyphen(value);
                this.search.requestDate = value;
            }
        }
    },
    methods: {
        /** --------------------------------------------
        * リクエスト予約情報を取得
        * -------------------------------------------- */
        getReserveRequestList () {
            this.$apollo.query({
                query: GET_RESERVE_REQUEST_LIST,
                fetchPolicy: 'no-cache',
                variables: {
                    golf_group_code: process.env.VUE_APP_GROUP_CODE,
                    golf_code: this.search.golfCode,
                    reserve_no: this.search.reserveNo,
                    reserve_type: this.search.reserveType,
                    application_date: this.search.applicationDate,
                    reserve_situation: this.search.reserveSituation,
                    member_no: this.search.memberNo,
                    family_name: this.search.familyName,
                    given_name: this.search.givenName,
                    request_date: this.search.requestDate,
                    message_completed: this.search.completed,
                    begin_row: this.begin_row,
                    cancel_begin_row: this.cancel_begin_row,
                    limit_rows: this.limit_rows
                }
            }).then(res => {
                const count = res.data.getReserveRequestList.count;
                this.pageCount = Math.ceil(count / this.limit_rows);
                this.desserts = res.data.getReserveRequestList.ReserveList;
                this.cancelList = res.data.getReserveRequestList.CancelReserveList;
                const cancelCount = res.data.getReserveRequestList.CancelCount;
                this.cancelPageCount = Math.ceil(cancelCount / this.limit_rows);
            }).catch(error => {
                this.error = error;
            });
        },
        /** ----------------------------------------------
         * チェック処理
         * ---------------------------------------------- */
        checkValidateSearch () {
            if (this.$refs.form.validate()) {
                this.clickSearch();
            } else {
                return false;
            }
        },
        /** ----------------------------------------------
         * 検索処理
         * ---------------------------------------------- */
        clickSearch () {
            this.page = 1;
            this.cancelPage = 1;
            this.begin_row = 0;
            this.cancel_begin_row = 0;
            this.getReserveRequestList();
        },
        /** ----------------------------------------------
         * ページネーション処理
         * ---------------------------------------------- */
        clickPagination () {
            this.begin_row = this.page * this.limit_rows - this.limit_rows;
            this.cancel_begin_row = this.cancelPage * this.limit_rows - this.limit_rows;
            this.getReserveRequestList();
        },
        /** ----------------------------------------------
         * 子コンポーネントの表示処理
         * ---------------------------------------------- */
        openModal (data) {
            this.detailInfo.reserve_no = data.reserve_no;
            this.detailInfo.member_no = data.member_no;
            this.$refs.Modal.openModal();
        },
        /** ----------------------------------------------
         * 日付フォーマット処理
         * ---------------------------------------------- */
        deleteKeyUpApplicationDate (event) {
            this.search.applicationDate = this.formatDate(this.search.applicationDate);
            this.search.applicationDate = this.deleteKeyDelete(event);
        },
        /** ----------------------------------------------
         * 日付フォーマット処理
         * ---------------------------------------------- */
        deleteKeyUpPlayDate (event) {
            this.search.requestDate = this.formatDate(this.search.requestDate);
            this.search.requestDate = this.deleteKeyDelete(event);
        }
    }
};
</script>

<style scoped>
.selectWidth {
    width: 200px;
}
.date-width {
    width: 110px;
}
.column-width {
    width: 130px;
}
.golf-width {
    width: 300px;
}
.reserve-title {
    font-size: 24px;
}
.v-data-table ::v-deep td {
    word-break: break-word;
    padding: 0px 12px;
    font-size: .875rem;
    height: 35px;
}
</style>
